import { Spin } from "antd";

export default function LogicLessSyncSpinner({style={}, className=""}) {
    return (
        <div style={{fontWeight: 600, color: "var(--zero-light-blue)", ...style}} className={className}>
            <Spin size="small"/><span className="mar-lft-10">Sync in progress...</span>
        </div>
    )
}